import React from 'react';
import { Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import FeedbackBadIcon from '../Icon/FeedbackBadIcon';
import Typography from '@material-ui/core/Typography';
import FeedbackNeutralIcon from '../Icon/FeedbackNeutralIcon';
import FeedbackGoodIcon from '../Icon/FeedbackGoodIcon';
import makeStyles from '@material-ui/core/styles/makeStyles';
export const useStyles = makeStyles(() => (
  {
    dialogContent: {
      textAlign: 'center',
    },
    icon: {
      width: '60px',
      height: '60px',
    },
    dialogTitle: {
      marginTop: '10px',
      marginBottom: '10px',
    },
  }
));
const FeedbackDialog = (props) => {
  const {open, handleClose, modalFeedback, modalFeedbackOpinion} = props;

  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogContent className={classes.dialogContent}>
        {modalFeedbackOpinion === 'bad'
        && <React.Fragment>
          <FeedbackBadIcon className={classes.icon} />
          <Typography className={classes.dialogTitle} variant={'subtitle1'}>
            Pas du tout satisfait
          </Typography>
        </React.Fragment>
        }
        {modalFeedbackOpinion === 'neutral'
        && <React.Fragment>
          <FeedbackNeutralIcon className={classes.icon} />
          <Typography className={classes.dialogTitle} variant={'subtitle1'}>
            Moyennement satisfait
          </Typography>
        </React.Fragment>
        }
        {modalFeedbackOpinion === 'good'
        && <React.Fragment>
          <FeedbackGoodIcon className={classes.icon} />
          <Typography className={classes.dialogTitle} variant={'subtitle1'}>
            Très satisfait
          </Typography>
        </React.Fragment>
        }
        <DialogContentText variant={'body1'} align={'justify'}>
          {modalFeedback}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackDialog;



// WEBPACK FOOTER //
// ./src/components/Feedback/FeedbackDialog.jsx